import colors from "./colors";
import typography from "./typography";
import { fontSizes } from "./sizes";

export const theme = {
  colors,
  typography,
  fontSizes,
};
